import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { RootState } from "../../../../../redux/store";
import JoinRoom from "../../../../../zoom/JoinRoom";

const PublicVideoLayout = () => {
  const navigate = useNavigate();
  const isOpenJoinRoom: boolean = useSelector(
    (state: RootState) => state.joinRoom?.opened
  );

  useEffect(() => {
    if (!!isOpenJoinRoom) {
      navigate(-1);
    }
  }, [isOpenJoinRoom]);

  return !!isOpenJoinRoom ? <JoinRoom /> : <Outlet />;
};

export default PublicVideoLayout;
